export default function LiquidityHeader(props) {
  const { className, children } = props;
  return <div className={`liquidity-header ${className}`}>{children}</div>;
}
